<template>
  <div id="dashboard">
    <section class="bannerprincipal pb-2">
      <SiteNav></SiteNav>
      <div
        class="col-12 text-center py-3"
        data-aos="fade-down"
        data-aos-delay="100"
      >
        <div class="row"></div>
      </div>

      <div
        class="separador text-center mt-5 py-5"
        data-aos="fade-up"
        data-aos-delay="600"
      >
        <p class="fXG amarillo">Administrador</p>
      </div>

      <div class="container-fluid bgblanco py-3">
        <!-- <div class="row pb-5">
        <div class="col-12 blockd fG amarillo">Semana 1</div>
      </div>-->

        <b-tabs content-class="mt-3 row">
          <b-tab title="Registros" active @click="initDashboard()">
            <div class="row px-2">
              <div class="col-md-6" v-if="user.id != 1">
                <div class="row pl-2">
                  <div class="col-12 py-4">
                    <table
                      border="0"
                      cellspacing="0"
                      cellpadding="0"
                      width="876"
                    >
                      <tbody>
                        <tr>
                          <td width="111"></td>
                          <!-- <td width="165">
                            <p align="center">Tope de registros</p>
                          </td> -->
                          <td width="165">
                            <p align="center">Registros en BD</p>
                          </td>
                          <td width="165">
                            <p align="center">Asistirán</p>
                          </td>
                          <td width="165">
                            <p align="center">No asistirán</p>
                          </td>
                          <td width="165">
                            <p align="center">Torneo</p>
                          </td>
                          <td width="165">
                            <p align="center">Clínica</p>
                          </td>
                          <td width="165">
                            <p align="center">Comida</p>
                          </td>
                          <td width="165">
                            <p align="center">Stand</p>
                          </td>
                          <td width="165">
                            <p align="center">Asistiendo</p>
                          </td>
                        </tr>

                        <tr>
                          <td width="111">
                            <p align="center">
                              <strong>Clientes</strong>
                            </p>
                          </td>
                          <!-- <td width="165">
                            <p class="small">
                              <strong>&nbsp;</strong>
                            </p>
                          </td> -->
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_cliente }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ clientes_si }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ clientes_no }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_torneo_cliente }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_clinica_cliente }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_comida_cliente }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>0</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ clientes_asistiendo }}</strong>
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td width="111">
                            <p align="center">
                              <strong>Clientes Top</strong>
                            </p>
                          </td>
                          <!-- <td width="165">
                            <p class="small">
                              <strong>&nbsp;</strong>
                            </p>
                          </td> -->
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_cliente_top }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ clientes_top_si }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ clientes_top_no }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_torneo_cliente_top }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{
                                contador_clinica_cliente_top
                              }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_comida_cliente_top }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>0</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ clientes_top_asistiendo }}</strong>
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td width="111">
                            <p align="center">
                              <strong>Invitados Top</strong>
                            </p>
                          </td>
                          <!-- <td width="165">
                            <p class="small">
                              <strong>&nbsp;</strong>
                            </p>
                          </td> -->
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_invitado_top }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ invitados_top_si }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ invitados_top_no }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_torneo_invitado_top }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{
                                contador_clinica_invitado_top
                              }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_comida_invitado_top }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>0</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ invitados_top_asistiendo }}</strong>
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td width="111">
                            <p>
                              <strong>Equipo Prosa</strong>
                            </p>
                          </td>
                          <!-- <td width="165">
                            <p align="center">
                              <strong>{{ tope_equipo_prosa }}</strong>
                            </p>
                          </td> -->
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_equipo_prosa }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ equipo_prosa_si }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ equipo_prosa_no }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_torneo_prosa }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_clinica_prosa }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_comida_prosa }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>0</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ equipo_prosa_asistiendo }}</strong>
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td width="111">
                            <p>
                              <strong>Patrocinadores</strong>
                            </p>
                          </td>
                          <!-- <td width="165">
                            <p align="center">
                              <strong>{{ tope_patrocinios }}</strong>
                            </p>
                          </td> -->
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_patrocinador }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ patrocinios_si }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ patrocinios_no }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{
                                contador_torneo_patrocinador
                              }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{
                                contador_clinica_patrocinador
                              }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{
                                contador_comida_patrocinador
                              }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_stand_patrocinador }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ patrocinios_asistiendo }}</strong>
                            </p>
                          </td>
                        </tr>


                        <tr>
                          <td width="111">
                            <p>
                              <strong>Agencia</strong>
                            </p>
                          </td>
                          <!-- <td width="165">
                            <p align="center">
                              <strong>{{ tope_patrocinios }}</strong>
                            </p>
                          </td> -->
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_agencia }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ agencia_si }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ agencia_no }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{
                                contador_torneo_agencia
                              }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{
                                contador_clinica_agencia
                              }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{
                                contador_comida_agencia
                              }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>0</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ agencia_asistiendo }}</strong>
                            </p>
                          </td>
                        </tr>


                        <!-- <tr>
                          <td width="111">
                            <p>
                              <strong>Stand</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ tope_patrocinios }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_stand }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ stand_si }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ stand_no }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{
                                contador_torneo_stand
                              }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{
                                contador_clinica_stand
                              }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{
                                contador_comida_stand
                              }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ stand_asistiendo }}</strong>
                            </p>
                          </td>
                        </tr> -->

                        <tr>
                          <td width="111">
                            <p>
                              <strong>TOTALES</strong>
                            </p>
                          </td>
                          <!-- <td width="165">
                            <strong>{{
                              tope_clientes +
                              tope_equipo_prosa +
                              tope_patrocinios
                            }}</strong>
                          </td> -->
                          <td width="165">
                            <p align="center">
                              <strong>{{
                                contador_cliente +
                                contador_cliente_top +
                                contador_agencia +
                                contador_invitado_top +
                                contador_equipo_prosa +
                                contador_patrocinador
                              }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{
                                clientes_si +
                                clientes_top_si +
                                agencia_si +
                                invitados_top_si +
                                equipo_prosa_si +
                                patrocinios_si
                              }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{
                                clientes_no +
                                clientes_top_no +
                                agencia_no +
                                invitados_top_no +
                                equipo_prosa_no +
                                patrocinios_no
                              }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{
                                contador_torneo_cliente +
                                contador_torneo_cliente_top +
                                contador_torneo_agencia +
                                contador_torneo_invitado_top +
                                contador_torneo_prosa +
                                contador_torneo_patrocinador
                              }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{
                                contador_clinica_cliente +
                                contador_clinica_cliente_top +
                                contador_clinica_agencia +
                                contador_clinica_invitado_top +
                                contador_clinica_prosa +
                                contador_clinica_patrocinador
                              }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{
                                contador_comida_cliente +
                                contador_comida_cliente_top +
                                contador_comida_agencia +
                                contador_comida_invitado_top +
                                contador_comida_prosa +
                                contador_comida_patrocinador
                              }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{ contador_stand_patrocinador }}</strong>
                            </p>
                          </td>
                          <td width="165">
                            <p align="center">
                              <strong>{{
                                clientes_asistiendo +
                                clientes_top_asistiendo +
                                agencia_asistiendo +
                                invitados_top_asistiendo +
                                equipo_prosa_asistiendo +
                                patrocinios_asistiendo
                              }}</strong>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="row">
                      <div class="col-12 py-5">
                        <table
                          border="0"
                          cellspacing="0"
                          cellpadding="0"
                          width="876"
                          class="text-center"
                        >
                          <thead>
                            <th>&nbsp;</th>
                            <th align="center">Topes</th>
                            <th align="center">Disponibles</th>
                            <th align="center">Usados</th>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <strong>Comida: </strong>
                              </td>
                              <td align="center">
                                {{ topesForm.cuenta_comida }}
                              </td>
                              <td align="center">
                                {{ cuenta_comida }}
                              </td>
                              <td align="center">
                                {{ topesForm.cuenta_comida - cuenta_comida }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Clínica 10 am: </strong>
                              </td>
                              <td align="center">
                                {{ topesForm.cuenta_10am }}
                              </td>
                              <td align="center">
                                {{ cuenta_10am }}
                              </td>
                              <td align="center">
                                {{ topesForm.cuenta_10am - cuenta_10am }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Clínica 11 am: </strong>
                              </td>
                              <td align="center">
                                {{ topesForm.cuenta_11am }}
                              </td>
                              <td align="center">
                                {{ cuenta_11am }}
                              </td>
                              <td align="center">
                                {{ topesForm.cuenta_11am - cuenta_11am }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Clínica 12 pm: </strong>
                              </td>
                              <td align="center">
                                {{ topesForm.cuenta_12pm }}
                              </td>
                              <td align="center">
                                {{ cuenta_12pm }}
                              </td>
                              <td align="center">
                                {{ topesForm.cuenta_12pm - cuenta_12pm }}
                              </td>
                            </tr>
                            <!-- <tr>
                              <td>
                                <strong>Clínica 1 pm: </strong>
                              </td>
                              <td align="center">
                                {{ topesForm.cuenta_1pm }}
                              </td>
                              <td align="center">
                                {{ cuenta_1pm }}
                              </td>
                              <td align="center">
                                {{ topesForm.cuenta_1pm - cuenta_1pm }}
                              </td>
                            </tr> -->
                            <tr>
                              <td>
                                <strong>Torneo: </strong>
                              </td>
                              <td align="center">
                                {{ topesForm.cuenta_torneo }}
                              </td>
                              <td align="center">
                                {{ cuenta_torneo }}
                              </td>
                              <td align="center">
                                {{ topesForm.cuenta_torneo - cuenta_torneo }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="col-12 negro pt-3 pb-3">
                    <span class="fG bold">Totales</span>
                    (Total: {{ registros.length }})
                  </div> -->
                </div>
              </div>

              <!-- <div class="col-12" v-if="user.id == 1">
                <div class="row">
                  <div class="col-md-6">
                    <div class="col-12 negro pt-2 pb-3">
                      <span class="fG"
                        >Usuarios confirmados para <b>TORNEO</b>:
                        {{ contador_torneo }}</span
                      >
                    </div>
                    <div class="col-12 negro pt-2 pb-3">
                      <span class="fG"
                        >Usuarios confirmados para <b>CLINICA</b>:
                        {{ contador_clinica }}</span
                      >
                    </div>
                    <div class="col-12 negro pt-2 pb-5">
                      <span class="fG"
                        >Usuarios confirmados para <b>COMIDA</b>:
                        {{ contador_comida }}</span
                      >
                    </div>

                    <div class="col-12 negro pt-2 pb-3">
                      <span class="fG"
                        >Invitados tipo <b>CLIENTE</b>:
                        {{ contador_cliente }}</span
                      >
                    </div>
                    <div class="col-12 negro pt-2 pb-3">
                      <span class="fG"
                        >Invitados tipo <b>EQUIPO PROSA</b>:
                        {{ contador_equipo_prosa }}</span
                      >
                    </div>
                    <div class="col-12 negro pt-2 pb-5">
                      <span class="fG"
                        >Invitados tipo <b>PATROCINADOR</b>:
                        {{ contador_patrocinador }}</span
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row pl-2">
                      <div class="col-12 negro pt-3 pb-1">
                        <span class="fG bold">Torneo</span>
                      </div>
                      <div class="col-12 negro pb-1">
                        <span class="fG"
                          >CLIENTE: {{ contador_torneo_cliente }}</span
                        >
                      </div>
                      <div class="col-12 negro pb-1">
                        <span class="fG"
                          >EQUIPO PROSA: {{ contador_torneo_prosa }}</span
                        >
                      </div>
                      <div class="col-12 negro pb-2">
                        <span class="fG"
                          >PATROCINADOR:
                          {{ contador_torneo_patrocinador }}</span
                        >
                      </div>
                    </div>
                    <div class="row pl-2">
                      <div class="col-12 negro pt-3 pb-1">
                        <span class="fG bold">Clínica</span>
                      </div>
                      <div class="col-12 negro pb-1">
                        <span class="fG"
                          >CLIENTE: {{ contador_clinica_cliente }}</span
                        >
                      </div>
                      <div class="col-12 negro pb-1">
                        <span class="fG"
                          >EQUIPO PROSA: {{ contador_clinica_prosa }}</span
                        >
                      </div>
                      <div class="col-12 negro pb-2">
                        <span class="fG"
                          >PATROCINADOR:
                          {{ contador_clinica_patrocinador }}</span
                        >
                      </div>
                    </div>
                    <div class="row pl-2">
                      <div class="col-12 negro pt-3 pb-1">
                        <span class="fG bold">Comida</span>
                      </div>
                      <div class="col-12 negro pb-1">
                        <span class="fG"
                          >CLIENTE: {{ contador_comida_cliente }}</span
                        >
                      </div>
                      <div class="col-12 negro pb-1">
                        <span class="fG"
                          >EQUIPO PROSA: {{ contador_comida_prosa }}</span
                        >
                      </div>
                      <div class="col-12 negro pb-2">
                        <span class="fG"
                          >PATROCINADOR:
                          {{ contador_comida_patrocinador }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->

              <div class="col-12 negro">
                <span class="fG px-3">Filtrar por Asistencia al Evento:</span>
              </div>

              <div class="col-6 negro pb-3">
                <select
                  @change="filtrarAsistencia($event)"
                  class="form-control"
                  v-model="filtro_asistencia"
                >
                  <option value="">TODOS</option>
                  <option value="TORNEO">TORNEO</option>
                  <option value="CLINICA">CLINICA</option>
                  <option value="COMIDA">COMIDA</option>
                  <option value="NO ASISTIRA">NO ASISTIRA</option>
                </select>
              </div>


              <div class="col-12 negro">
                <span class="fG px-3">Filtrar por Tipo de Registro:</span>
              </div>

              <div class="col-6 negro pb-3">
                <select
                  @change="filtrarAsistencia($event)"
                  class="form-control"
                  v-model="filtro_tipo"
                >
                  <option value="">TODOS</option>
                  <option value="INVITADO TOP">INVITADO TOP</option>
                  <option value="CLIENTE TOP">CLIENTE TOP</option>
                  <option value="EQUIPO PROSA">EQUIPO PROSA</option>
                  <option value="CLIENTE">CLIENTE</option>
                  <option value="PATROCINADOR">PATROCINADOR</option>
                  <option value="STAND">STAND</option>
                  <option value="STAFF">STAFF</option>
                  <option value="EDECANES">EDECANES</option>
                  <option value="AGENCIA">AGENCIA</option>
                  
                </select>
              </div>

              <div class="col-12">
                <download-excel
                  :data="this.registros"
                  name="Copa Prosa Registros.xls"
                >
                  <button class="btn btn-danger">Exportar Registros</button>
                </download-excel>
              </div>
              <div class="col-12">
                <v-client-table
                  class=""
                  :columns="columnsRegistros"
                  v-model="registros"
                  :options="options"
                >
                  <div slot="child_row" slot-scope="props" class="">
                    <!-- <a
                    slot="id"
                    slot-scope="props"
                    target="_blank"
                    :href="'/administrador/edicion-registro/'+props.row.id"
                    class=""
                    >Ver</a
                  > -->

                    <div class="row py-3">
                      <div class="px-3 pb-3 col-md-12 text-left">
                        <div class="row">
                          <div class="col-6">
                            <p>
                              <router-link
                                class="btnaction"
                                target="_blank"
                                :to="
                                  '/administrador/edicion-registro/' +
                                  props.row.id
                                "
                                v-if="user.id == 2 || user.id == 3"
                              >
                                <span class="blanco">Editar datos</span>
                              </router-link>

                              <button
                                class="btnaction ml-3"
                                target="_blank"
                                @click="reenvio(props.row.codigo)"
                                v-if="user.id == 2 || user.id == 3"
                              >
                                <span class="blanco">Reenviar QR</span>
                              </button>

                              <!-- <a target="_blank" class="pr-4" download :href="'https://api.qrserver.com/v1/create-qr-code/?size=300x300&data='+props.row.codigo"> -->
                              <button
                                v-if="user.id == 2 || user.id == 3"
                                @click="
                                  downloadImage(
                                    'https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=' +
                                      props.row.codigo,
                                    props.row.nombre_1 +
                                      ' ' +
                                      props.row.apellido_paterno,
                                    props.row.email
                                  )
                                "
                                width="100"
                                class="btnaction ml-3"
                                :src="
                                  'https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=' +
                                  props.row.codigo
                                "
                              >
                                <span class="blanco">Descargar QR</span>
                              </button>
                              <!-- </a> -->
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row pb-3">
                      <div class="px-3 pb-3 col-md-4 text-left">
                        <p>Asistencia a la comida</p>
                        <div class="row">
                          <div class="col-6">
                            <p>
                              <select
                                class="form-control negro"
                                name=""
                                id=""
                                v-model="props.row.comida"
                              >
                                <option value="" hidden>
                                  Asistencia a la comida
                                </option>
                                <option value="NO">NO</option>
                                <option value="SI">SI</option>
                              </select>
                            </p>
                          </div>
                          <div class="col-6">
                            <p>
                              <button
                                class="btnaction"
                                @click="
                                  changeStatusComida(
                                    props.row.codigo,
                                    props.row.comida
                                  )
                                "
                              >
                                <span class="negro">Actualizar</span>
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row pb-3">
                      <div class="px-3 pb-3 col-md-4 text-left">
                        <p>Asistencia al torneo</p>
                        <div class="row">
                          <div class="col-6">
                            <p>
                              <select
                                class="form-control negro"
                                name=""
                                id=""
                                v-model="props.row.torneo"
                              >
                                <option value="" hidden>
                                  Asistencia al torneo
                                </option>
                                <option value="NO">NO</option>
                                <option value="SI">SI</option>
                              </select>
                            </p>
                          </div>
                          <div class="col-6">
                            <p>
                              <button
                                class="btnaction"
                                @click="
                                  changeStatusTorneo(
                                    props.row.codigo,
                                    props.row.torneo
                                  )
                                "
                              >
                                <span class="negro">Actualizar</span>
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row pb-3" v-if="props.row.torneo == 'SI'">
                      <div class="px-3 pb-3 col-md-4 text-left">
                        <p>Selecciona la talla de zapatos:</p>
                        <div class="row">
                          <div class="col-6">
                            <p>
                              <select
                                class="form-control negro"
                                name=""
                                id=""
                                v-model="props.row.talla_zapatos"
                              >
                              <option value="">TALLA DE ZAPATOS*</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="8">8</option>
                              <option value="9">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                              <option value="13">13</option>
                              <option value="14">14</option>
                              <option value="15">15</option>
                              </select>
                            </p>
                          </div>
                          <div class="col-6">
                            <p>
                              <button
                                class="btnaction"
                                @click="
                                  changeStatusZapatos(
                                    props.row.codigo,
                                    props.row.talla_zapatos
                                  )
                                "
                              >
                                <span class="negro">Actualizar</span>
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row pb-3" v-if="props.row.torneo == 'SI'">
                      <div class="px-3 pb-3 col-md-4 text-left">
                        <p>Ingresa el handicap:</p>
                        <div class="row">
                          <div class="col-6">
                            <p>
                              <input
                                class="form-control"
                                v-model.trim="props.row.handicap"
                                type="text"
                                placeholder="Handicap*"
                                required
                              />
                            </p>
                          </div>
                          <div class="col-6">
                            <p>
                              <button
                                class="btnaction"
                                @click="
                                  changeStatusHandicap(
                                    props.row.codigo,
                                    props.row.handicap
                                  )
                                "
                              >
                                <span class="negro">Actualizar</span>
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row pb-3">
                      <div class="px-3 pb-3 col-md-4 text-left">
                        <p>Asistencia a la clínica</p>
                        <div class="row">
                          <div class="col-6">
                            <p>
                              <select
                                class="form-control negro"
                                name=""
                                id=""
                                v-model="props.row.clinica"
                              >
                                <option value="" hidden>
                                  Asistencia a la clínica
                                </option>
                                <option value="NO">NO</option>
                                <option value="SI">SI</option>
                              </select>
                            </p>
                          </div>
                          <div class="col-6">
                            <p>
                              <button
                                class="btnaction"
                                @click="
                                  changeStatusClinica(
                                    props.row.codigo,
                                    props.row.clinica
                                  )
                                "
                              >
                                <span class="negro">Actualizar</span>
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row pb-3">
                      <div
                        class="px-3 pb-3 col-md-4 text-left"
                        v-if="props.row.clinica == 'SI'"
                      >
                        <p>Talla de guantes</p>
                        <div class="row">
                          <div class="col-6">
                            <p>
                              <select
                                class="form-control negro"
                                name=""
                                id=""
                                v-model="props.row.talla_guantes"
                              >
                                <option value="" hidden>Talla de guante</option>
                                <option value="S">S</option>
                                <option value="M">M</option>
                                <option value="L">L</option>
                                <option value="XL">XL</option>
                              </select>
                            </p>
                          </div>
                          <div class="col-6">
                            <p>
                              <button
                                class="btnaction"
                                @click="
                                  changeStatusGuantes(
                                    props.row.codigo,
                                    props.row.talla_guantes
                                  )
                                "
                              >
                                <span class="negro">Actualizar</span>
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row pb-3" v-if="props.row.clinica == 'SI'">
                      <div class="px-3 pb-3 col-md-4 text-left">
                        <p>Selecciona un horario de la clínica</p>
                        <div class="row">
                          <div class="col-6">
                            <p>
                              <select
                                class="form-control negro"
                                name=""
                                id=""
                                v-model="props.row.horario_clinica"
                              >
                                <option value="" hidden>
                                  Selecciona un horario de la clínica
                                </option>
                                <option value="10 am">10 am</option>
                                <option value="11 am">11 am</option>
                                <option value="12 pm">12 pm</option>
                                <option value="1 pm">1 pm</option>
                              </select>
                            </p>
                          </div>
                          <div class="col-6">
                            <p>
                              <button
                                class="btnaction"
                                @click="
                                  changeStatusHorarioClinica(
                                    props.row.codigo,
                                    props.row.horario_clinica
                                  )
                                "
                              >
                                <span class="negro">Actualizar</span>
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-client-table>
              </div>
            </div>
          </b-tab>

          <b-tab title="Invitados" @click="getInvitados()">
            <div class>
              <div class="col-12 negro pt-5 pb-3">
                <span class="blockd fG">Invitados</span>
                (Total: {{ invitados.length }})
              </div>

              <div class="col-12">
                <download-excel :data="this.invitados" name="Invitados">
                  <button class="btn btn-danger">Exportar invitados</button>
                </download-excel>
              </div>
              <div class="col-12">
                <v-client-table
                  class=""
                  :columns="columnsInvitados"
                  v-model="invitados"
                  :options="options"
                >
                  <div slot="child_row" slot-scope="props" class="">
                    <div class="row py-3">
                      <div class="px-3 pb-3 col-md-12 text-left">
                        <div class="row">
                          <div class="col-12">
                            <p>
                              <router-link
                                class="btnaction"
                                target="_blank"
                                :to="
                                  '/administrador/edicion-invitados/' +
                                  props.row.id
                                "
                                v-if="user.id == 2 || user.id == 3"
                              >
                                <span class="blanco">Editar datos</span>
                              </router-link>

                              <button
                                class="btnaction ml-4"
                                target="_blank"
                                @click="enviarInvitacion(props.row.email)"
                                v-if="user.id == 2 || user.id == 3"
                              >
                                <span class="blanco">Enviar invitación</span>
                              </button>

                              <router-link
                                class="btnaction ml-4"
                                :to="
                                  '/administrador/completar-registro/' +
                                  props.row.id
                                "
                                v-if="user.id == 2 || user.id == 3"
                              >
                                <span class="blanco"
                                  >Registrar asistencia al evento</span
                                >
                              </router-link>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-client-table>
              </div>
            </div>
          </b-tab>

          <b-tab
            title="Registro de invitados"
            @click="getCodigoYDiponibilidad()"
          >
            <div class="row px-5">
              <div
                class="col-md-12 pt-5 mt-5"
                data-aos="fade-left"
                data-aos-delay="500"
              >
                <form @submit="signupInvitado($event)" class="pb-5 r15 mr-lg-5">
                  <div class="col-12 text-left pb-4 fXG">
                    <span class="">REGISTRO DE INVITADO</span>
                  </div>
                  <div class="col-12">
                    <div class="row pb-4">
                      <!-- <div class="col-lg-12 pb-0">

                    <input
                      v-model.trim="signupForm.codigo"
                      type="text"
                      placeholder="Clave de registro*"
                      required
                      readonly
                    />
                  </div> -->
                      <div class="col-lg-12 pb-0">
                        <!-- <div class="blanco fG">Nombre</div> -->
                        <input
                          v-model.trim="signupForm.nombre_1"
                          type="text"
                          placeholder="Nombre*"
                          @input="
                            signupForm.nombre_1 =
                              $event.target.value.toUpperCase()
                          "
                          required
                        />
                      </div>
                      <div class="col-lg-12 pb-0">
                        <!-- <div class="blanco fG">Nombre</div> -->
                        <input
                          v-model.trim="signupForm.nombre_2"
                          type="text"
                          placeholder="Segundo Nombre"
                          @input="
                            signupForm.nombre_2 =
                              $event.target.value.toUpperCase()
                          "
                        />
                      </div>
                      <div class="col-lg-12 pb-0">
                        <!-- <div class="blanco fG">Apellido</div> -->
                        <input
                          v-model.trim="signupForm.apellido_paterno"
                          type="text"
                          placeholder="Apellido Paterno*"
                          @input="
                            signupForm.apellido_paterno =
                              $event.target.value.toUpperCase()
                          "
                          required
                        />
                      </div>
                      <div class="col-lg-12 pb-0">
                        <!-- <div class="blanco fG">Apellido</div> -->
                        <input
                          v-model.trim="signupForm.apellido_materno"
                          type="text"
                          placeholder="Apellido Materno"
                          @input="
                            signupForm.apellido_materno =
                              $event.target.value.toUpperCase()
                          "
                        />
                      </div>
                      <div class="col-lg-12 pb-0">
                        <!-- <div class="blanco fG">Apellido</div> -->
                        <input
                          v-model.trim="signupForm.empresa"
                          type="text"
                          placeholder="Empresa*"
                          @input="
                            signupForm.empresa =
                              $event.target.value.toUpperCase()
                          "
                          required
                        />
                      </div>
                      <div class="col-lg-12 pb-0">
                        <!-- <div class="blanco fG">Apellido</div> -->
                        <input
                          v-model.trim="signupForm.puesto"
                          type="text"
                          placeholder="Puesto*"
                          @input="
                            signupForm.puesto =
                              $event.target.value.toUpperCase()
                          "
                          required
                        />
                      </div>
                      <div class="col-lg-12 pb-0">
                        <!-- <div class="blanco fG">Apellido</div> -->
                        <input
                          v-model.trim="signupForm.email_user"
                          type="email"
                          placeholder="Correo Electrónico*"
                          @input="
                            signupForm.email_user =
                              $event.target.value.toLowerCase()
                          "
                          required
                        />
                      </div>
                      <div class="col-lg-12">
                        <div class="row">
                          <!-- <div class="col-lg-5 pb-0">

                        <select v-model="signupForm.codigo_pais" required>
                          <option value="">Código País</option>

                          <option value="+52">MÉXICO +52</option>
                          <option value="+1">ESTADOS UNIDOS +1</option>
                          <option value="+1">CANADÁ +1</option>
                          <option value="+55">BRASIL +55</option>

                        </select>
                      </div> -->

                          <div class="col-lg-12 pb-0">
                            <!-- <div class="blanco fG">Correo Electrónico</div> -->
                            <input
                              v-model.trim="signupForm.telefono"
                              type="tel"
                              placeholder="Teléfono"
                              maxlength="10"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-12 pb-0">
                        <!-- <div class="blanco fG">Apellido</div> -->
                        <input
                          v-model.trim="signupForm.movil"
                          type="tel"
                          placeholder="Móvil"
                          maxlength="10"
                        />
                      </div>

                      <div class="col-lg-12 pb-0">
                        <div class="">Tipo de asistente*</div>
                        <select v-model="signupForm.tipo" required>
                          <option value="">Tipo de asistente</option>
                          <option value="EQUIPO PROSA">EQUIPO PROSA</option>
                          <option value="PATROCINADOR">PATROCINADOR</option>
                          <option value="CLIENTE">CLIENTE</option>
                          <!-- <option value="STAND">STAND</option> -->
                        </select>
                      </div>

                      <div class="col-lg-12 pb-0">
                        <div class="">Prioridad del asistente</div>
                        <select v-model="signupForm.prioridad">
                          <option value="">Prioridad del asistente</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="VIP">VIP</option>
                        </select>
                      </div>

                      <!-- <div class="col-lg-12 py-3">
                    <span class="pl-2"> ¿Asistirá a la comida?</span>
                    <br />
                    <label class="pointer">
                      <select
                        v-model="signupForm.comida"
                        @change="changeComida($event)"
                      >
                        <option value=""></option>
                        <option value="SI">SI</option>
                        <option value="NO">NO</option>
                      </select>
                    </label>
                  </div> -->

                      <!-- <div class="col-lg-12 py-3">
                    <span class="mt-4"
                      >Selecciona la actividad en la que participará:</span
                    >
                  </div> -->

                      <!-- <div class="col-lg-12 py-3">
                    <label class="pointer">
                      <select
                        v-model="signupForm.evento"
                        @change="changeEvento($event)"
                        required
                      >
                        <option value="">Actividad</option>
                        <option value="Ninguno">Ninguno</option>
                        <option value="Torneo">Torneo</option>
                        <option value="Clínica">Clínica de Golf</option>
                      </select>
                    </label>
                  </div> -->

                      <!-- <div class="col-lg-12 py-3">


                    <span class="blanco pl-2">
                      ¿Participarás en el Torneo?</span
                    >
                    <br />
                    <label class="pointer">
                      <select
                        v-model="signupForm.torneo"
                        @change="changeTorneo($event)"
                      >
                        <option value=""></option>
                        <option value="SI">SI</option>
                        <option value="NO">NO</option>
                      </select>
                    </label>
                  </div> -->
                      <div
                        class="col-lg-12 pb-0"
                        v-if="signupForm.torneo == 'SI'"
                      >
                        <!-- <div class="blanco fG">Apellido</div> -->
                        <input
                          v-model.trim="signupForm.handicap"
                          type="text"
                          placeholder="Handicap"
                        />
                      </div>
                    </div>

                    <div class="row pb-5">
                      <div class="col-12 text-center">
                        <button
                          type="submit"
                          class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto"
                        >
                          ENVIAR
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="extras text-center">
                    <a @click="toggleForm()" class="pointer"
                      >Regresar al Login</a
                    >
                  </div> -->
                </form>
              </div>
            </div>
          </b-tab>

          <b-tab
            title="Modificación de Topes"
            @click="getCodigoYDiponibilidad()"
          >
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <form class="row pb-3" @submit="changeTopes($event)">
                    <div class="px-3 pb-3 col-md-12 text-left">
                      <div class="row">
                        <div class="col-12">
                          <p>
                            <span>Tope Comida:</span>
                            <input
                              v-model.trim="topesForm.cuenta_comida"
                              type="number"
                              placeholder="Tope Comida"
                            />
                          </p>
                          <p>
                            <span>Tope Clínica 10 am:</span>
                            <input
                              v-model.trim="topesForm.cuenta_10am"
                              type="number"
                              placeholder="Tope Clínica 10 am"
                            />
                          </p>
                          <p>
                            <span>Tope Clínica 11 am:</span>
                            <input
                              v-model.trim="topesForm.cuenta_11am"
                              type="number"
                              placeholder="Tope Clínica 11 am"
                            />
                          </p>
                          <p>
                            <span>Tope Clínica 12 pm:</span>
                            <input
                              v-model.trim="topesForm.cuenta_12pm"
                              type="number"
                              placeholder="Tope Clínica 12 pm"
                            />
                          </p>
                          <!-- <p>
                            <span>Tope Clínica 1 pm:</span>
                            <input
                              v-model.trim="topesForm.cuenta_1pm"
                              type="number"
                              placeholder="Tope Clínica 1 pm"
                            />
                          </p> -->
                          <p>
                            <span>Tope Torneo:</span>
                            <input
                              v-model.trim="topesForm.cuenta_torneo"
                              type="number"
                              placeholder="Tope Torneo"
                            />
                          </p>
                        </div>
                        <div class="col-12">
                          <p>
                            <button class="btnaction" type="submit">
                              <span class="">Actualizar topes</span>
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>

        <div class="row">
          <div class="col-12 py-5"></div>
        </div>
        <div class="row">
          <div class="col-12 py-5"></div>
        </div>
        <div class="row">
          <div class="col-12 py-5"></div>
        </div>
        <div class="row">
          <div class="col-12 py-5"></div>
        </div>
        <div class="row">
          <div class="col-12 py-5"></div>
        </div>
      </div>

      <Footer></Footer>
      <!-- <Glyphicons></Glyphicons> -->
    </section>
  </div>
</template>


<script>
const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 42;
import Footer from "@/components/Footer";
// import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import SiteNav from "@/components/SiteNav2";

import * as fb from "../firebase";
import * as moment from "moment";
import { ticketsCollection, usersCollection } from "@/firebase";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    Footer,
    SiteNav,
    // Glyphicons,
  },
  data() {
    return {
      topesForm: {
        cuenta_comida: "",
        cuenta_10am: "",
        cuenta_11am: "",
        cuenta_12pm: "",
        cuenta_1pm: "",
        cuenta_torneo: "",
      },
      codigo_disponible: "",
      cuenta_10am: "",
      cuenta_11am: "",
      cuenta_12pm: "",
      cuenta_1pm: "",
      cuenta_torneo: "",
      cuenta_comida: "",
      reenvioForm: {
        codigo: "",
      },

      preForm: {
        codigo: "",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        codigo: "",
        nombre_1: "",
        nombre_2: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        codigo_pais: "",
        telefono: "",
        movil: "",
        comida: "NO",
        torneo: "NO",
        handicap: "",
        talla_tops: "",
        clinica: "NO",
        talla_guantes: "",
        horario_clinica: "",
        talla_cubrebocas: "",
        terminos: false,
      },

      columnsRegistros: [
        "codigo",
        "fecha_registro",
        "tipo",
        "asistira_al_evento",
        "email",
        "nombre_1",
        "nombre_2",
        "apellido_paterno",
        "apellido_materno",
        "empresa",
        "puesto",
        "codigo_pais",
        "telefono",
        "extension",
        "movil",
        "torneo",
        "handicap",
        "talla_zapatos",
        "clinica",
        "talla_guantes",
        "horario_clinica",
        "horario_10",
        "horario_11",
        "horario_12",
        "comida",
        "stand",
        "asistio",
        "fecha_asistio",
        "pulsera",
        "color_pulsera",
        "no_pulsera",
        "torneo_asistio",
        "kit_bienvenida",
        "zapatos",
        "talla_zapatos_entregado",
        "zapatera",
        "clinica_asistio",
        "clinica_horario_asistio",
        "guantes",
        "talla_guantes_entregado",
        "comida_asistio",
        "email_operador",
        "genero",
        "anfitrion",
        "registrado",
        "liga_personalizada",
        
      ],
      columnsInvitados: [
        "codigo",
        "enviado",
        "fecha_enviado",
        "fecha_registro",
        "tipo",
        "nombre_1",
        "nombre_2",
        "apellido_paterno",
        "apellido_materno",
        "empresa",
        "puesto",
        "email",
        "codigo_pais",
        "telefono",
        "movil",
      ],
      columnsSolicitudes: [
        "no_cliente",
        "nombre",
        "apellido",
        "email",
        "estado",
        "FechaRegistro",
      ],
      data: null,
      options: {
        perPage: 100,
        headings: {
          timestamp: "Fecha de registro",
          enviado: "Invitación enviada",
          fecha_enviado: "Fecha invitación enviada",
          email_operador: "Usuario que registró QR",
          cubrebocas: "Cubrebocas entregado",
          guantes: "Guantes entregado",
          kit_bienvenida: "Kit Torneo entregado",
          top: "Prenda superior entregada",
          pulsera: "Pulsera entregada",
          asistio: "Asistió al evento",
          talla_tops: "Talla Prenda Superior",
          no_pulsera: "No. de Pulsera",
          fecha_registro: "Fecha de registro",
        },
        editableColumns: [],
        sortable: [],
      },

      data_users: null,
      options_users: {
        perPage: 100,
        headings: {
          user_id: "UID",
          nombre: "Nombre",
          apellido: "Apellido",
          email: "Email",
          tel: "Tel",
          fecha_nacimiento: "Fec. Nac.",
          edad: "Edad",
          suma_puntos: "Suma Puntos",
          suma_time: "Suma Segundos",
          suma_time_txt: "Tiempo Total",
          num_tickets: "Número de Tickets",
          created_on: "Fecha de Registro",
          dia_registro: "Día de Registro",
        },
        editableColumns: [],
        sortable: [],
      },
      tickets: [],
      tickets_procesados: [],
      users: {},
      users_array: [],
      users_auth: [],
      centros: [],
      registros: [],
      invitados: [],
      user: null,
      contador_clinica: 0,
      contador_torneo: 0,
      contador_comida: 0,
      contador_equipo_prosa: 0,
      contador_cliente: 0,
      contador_agencia: 0,
      contador_cliente_top: 0,
      contador_invitado_top: 0,
      contador_patrocinador: 0,
      contador_stand: 0,
      contador_torneo_cliente: 0,
      contador_torneo_agencia: 0,
      contador_torneo_cliente_top: 0,
      contador_torneo_invitado_top: 0,
      contador_torneo_prosa: 0,
      contador_torneo_patrocinador: 0,
      contador_torneo_stand: 0,
      contador_clinica_cliente: 0,
      contador_clinica_agencia: 0,
      contador_clinica_cliente_top: 0,
      contador_clinica_invitado_top: 0,
      contador_clinica_prosa: 0,
      contador_clinica_patrocinador: 0,
      contador_clinica_stand: 0,
      contador_comida_cliente: 0,
      contador_comida_agencia: 0,
      contador_comida_cliente_top: 0,
      contador_comida_invitado_top: 0,
      contador_comida_prosa: 0,
      contador_comida_patrocinador: 0,

      contador_stand_patrocinador: 0,

      tope_clientes: 850,
      tope_equipo_prosa: 62,
      tope_patrocinios: 141,

      agencia_si: 0,
      agencia_no: 0,
      agencia_pendiente: 0,
      agencia_asistiendo: 0,

      clientes_si: 0,
      clientes_no: 0,
      clientes_pendiente: 0,
      clientes_asistiendo: 0,

      clientes_top_si: 0,
      clientes_top_no: 0,
      clientes_top_pendiente: 0,
      clientes_top_asistiendo: 0,

      invitados_top_si: 0,
      invitados_top_no: 0,
      invitados_top_pendiente: 0,
      invitados_top_asistiendo: 0,


      agencia: 0,
      clientes: 0,
      clientes_top: 0,
      invitados_top: 0,
      equipo_prosa: 0,
      patrocinios: 0,
      stand: 0,

      equipo_prosa_si: 0,
      equipo_prosa_no: 0,
      equipo_prosa_pendiente: 0,
      equipo_prosa_asistiendo: 0,

      patrocinios_si: 0,
      patrocinios_no: 0,
      patrocinios_pendiente: 0,
      patrocinios_asistiendo: 0,

      stand_si: 0,
      stand_no: 0,
      stand_pendiente: 0,
      stand_asistiendo: 0,

      sin_clasificar: 0,

      no_asistentes: 0,

      filtro_asistencia: "",
      filtro_tipo: "",
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.user = JSON.parse(localStorage.getItem("user_copaprosa2021"));

    this.initDashboard();
  },
  methods: {
    filtrarAsistencia(e) {
      this.getRegistros();
      this.getCodigoYDiponibilidad();
    },
    
    initDashboard() {
      this.getRegistros();
      this.getCodigoYDiponibilidad();
    },
    async changeStatusAsistenciaEvento(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusAsistenciaEvento.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeTopes(e) {
      e.preventDefault();
      console.log("change topes");

      this.$store.dispatch("showLoader", true);

      var qData = this.topesForm;

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusTopes.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            //this.getRegistros();

            swal.fire(
              "Bien",
              "Se han actualizado los datos correctamente.",
              "success"
            );
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusComida(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusComida.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusTorneo(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusTorneo.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
            this.getCodigoYDiponibilidad();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusClinica(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusClinica.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
            this.getCodigoYDiponibilidad();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusTalla(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusTalla.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusHandicap(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusHandicap.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusZapatos(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusZapatos.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusGuantes(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusGuantes.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusHorarioClinica(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusHorarioClinica.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
            this.getCodigoYDiponibilidad();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusCubrebocas(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusCubrebocas.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    getInvitados() {
      console.log("get invitados");

      const https = require("https");
      var qData = {
        // id: this.user.no_cliente,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getInvitados.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.invitados = res.datos;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    getRegistros() {
      console.log("get registros");
      this.$store.dispatch("showLoader", true);
      const https = require("https");
      var qData = {
        tipo_asistencia: this.filtro_asistencia,
        tipo_usuario: this.filtro_tipo,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getRegistros.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            console.log({ res });

            if (res.status == "ok") {
              this.registros = res.datos;

              this.cuentaRegistros();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    async cuentaRegistros() {
      this.contador_clinica = 0;
      this.contador_torneo = 0;
      this.contador_comida = 0;
      this.contador_stand = 0;

      this.contador_cliente = 0;
      this.contador_cliente_top = 0;
      this.contador_equipo_prosa = 0;
      this.contador_patrocinador = 0;
      this.contador_stand = 0;

      this.contador_torneo_cliente = 0;
      this.contador_torneo_cliente_top = 0;
      this.contador_torneo_invitado_top = 0;
      this.contador_torneo_prosa = 0;
      this.contador_torneo_patrocinador = 0;
      this.contador_torneo_stand = 0;
      this.contador_clinica_cliente = 0;
      this.contador_clinica_cliente_top = 0;
      this.contador_clinica_invitado_top = 0;
      this.contador_clinica_prosa = 0;
      this.contador_clinica_patrocinador = 0;
      this.contador_clinica_stand = 0;
      this.contador_comida_cliente = 0;
      this.contador_comida_cliente_top = 0;
      this.contador_comida_invitado_top = 0;
      this.contador_comida_prosa = 0;
      this.contador_comida_patrocinador = 0;
      this.contador_stand_patrocinador = 0;

      this.contador_comida_stand = 0;

      this.clientes_si = 0;
      this.clientes_no = 0;
      this.clientes_pendiente = 0;
      this.clientes_asistiendo = 0;

      this.clientes_top_si = 0;
      this.clientes_top_no = 0;
      this.clientes_top_pendiente = 0;
      this.clientes_top_asistiendo = 0;

      this.agencia_si = 0;
      this.agencia_no = 0;
      this.agencia_pendiente = 0;
      this.agencia_asistiendo = 0;

      this.invitados_top_si = 0;
      this.invitados_top_no = 0;
      this.invitados_top_pendiente = 0;
      this.invitados_top_asistiendo = 0;

      this.clientes = 0;
      this.agencia = 0;
      this.clientes_top = 0;
      this.invitados_top = 0;
      this.equipo_prosa = 0;
      this.patrocinios = 0;
      this.stand = 0;

      this.equipo_prosa_si = 0;
      this.equipo_prosa_no = 0;
      this.equipo_prosa_pendiente = 0;
      this.equipo_prosa_asistiendo = 0;

      this.patrocinios_si = 0;
      this.patrocinios_no = 0;
      this.patrocinios_pendiente = 0;
      this.patrocinios_asistiendo = 0;

      this.stand_si = 0;
      this.stand_no = 0;
      this.stand_pendiente = 0;
      this.stand_asistiendo = 0;

      this.sin_clasificar = 0;

      this.no_asistentes = 0;


      




      for (var i = 0; i < this.registros.length; i++) {


// // // // // // // // // if (this.registros[i].tipo.trim() == "PATROCINADOR") {
// // // // // // // // //             await this.downloadImage(
// // // // // // // // //                                     'https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=' +
// // // // // // // // //                                       this.registros[i].codigo,
// // // // // // // // //                                     this.registros[i].nombre_1 +
// // // // // // // // //                                       ' ' +
// // // // // // // // //                                       this.registros[i].apellido_paterno,
// // // // // // // // //                                       this.registros[i].email
// // // // // // // // //                                   )
// // // // // // // // //           }


        //torneo
        if (this.registros[i].torneo == "SI") {
          this.contador_torneo++;

          if (this.registros[i].tipo.trim() == "CLIENTE") {
            this.contador_torneo_cliente++;
          }
          if (this.registros[i].tipo.trim() == "AGENCIA") {
            this.contador_torneo_agencia++;
          }
          if (this.registros[i].tipo.trim() == "CLIENTE TOP") {
            this.contador_torneo_cliente_top++;
          }
          if (this.registros[i].tipo.trim() == "INVITADO TOP") {
            this.contador_torneo_invitado_top++;
          }
          if (this.registros[i].tipo.trim() == "EQUIPO PROSA") {
            this.contador_torneo_prosa++;
          }
          if (this.registros[i].tipo.trim() == "PATROCINADOR") {
            this.contador_torneo_patrocinador++;
          }
          if (this.registros[i].tipo.trim() == "STAND") {
            this.contador_torneo_stand++;
          }
        }

        //clinica
        if (this.registros[i].clinica == "SI") {
          this.contador_clinica++;

          if (this.registros[i].tipo.trim() == "CLIENTE") {
            this.contador_clinica_cliente++;
          }else 
          if (this.registros[i].tipo.trim() == "AGENCIA") {
            this.contador_clinica_agencia++;
          }else 
          if (this.registros[i].tipo.trim() == "CLIENTE TOP") {
            this.contador_clinica_cliente_top++;
          }else
          if (this.registros[i].tipo.trim() == "INVITADO TOP") {
            this.contador_clinica_invitado_top++;
          }else 
          if (this.registros[i].tipo.trim() == "EQUIPO PROSA") {
            this.contador_clinica_prosa++;
          }else
          if (this.registros[i].tipo.trim() == "PATROCINADOR") {
            this.contador_clinica_patrocinador++;
          }
        }

        //comida
        if (this.registros[i].comida == "SI") {
          this.contador_comida++;

          if (this.registros[i].tipo.trim() == "CLIENTE") {
            this.contador_comida_cliente++;
          }else
          if (this.registros[i].tipo.trim() == "AGENCIA") {
            this.contador_comida_agencia++;
          }else
          if (this.registros[i].tipo.trim() == "CLIENTE TOP") {
            this.contador_comida_cliente_top++;
          }else
          if (this.registros[i].tipo.trim() == "INVITADO TOP") {
            this.contador_comida_invitado_top++;
          }else
          if (this.registros[i].tipo.trim() == "EQUIPO PROSA") {
            this.contador_comida_prosa++;
          }else
          if (this.registros[i].tipo.trim() == "PATROCINADOR") {
            this.contador_comida_patrocinador++;
          }
          
        }

        //stand
        if (this.registros[i].stand == "SI") {
          this.contador_stand++;

          if (this.registros[i].tipo.trim() == "PATROCINADOR") {
            this.contador_stand_patrocinador++;
          }
        }

        //contador asistirán

        if (
          this.registros[i].torneo == "SI" ||
          this.registros[i].clinica == "SI" ||
          this.registros[i].stand == "SI"
        ) {
          if (this.registros[i].tipo.trim() == "CLIENTE") {
            this.clientes_si++;
          }
          if (this.registros[i].tipo.trim() == "AGENCIA") {
            this.agencia_si++;
          }
          if (this.registros[i].tipo.trim() == "CLIENTE TOP") {
            this.clientes_top_si++;
          }
          if (this.registros[i].tipo.trim() == "INVITADO TOP") {
            this.invitados_top_si++;
          }
          if (this.registros[i].tipo.trim() == "EQUIPO PROSA") {
            this.equipo_prosa_si++;
          }
          if (this.registros[i].tipo.trim() == "PATROCINADOR") {
            this.patrocinios_si++;
          }
          if (this.registros[i].tipo.trim() == "STAND") {
            this.stand_si++;
          }
        } else if (this.registros[i].comida == "SI") {
          if (this.registros[i].tipo.trim() == "CLIENTE") {
            this.clientes_si++;
          }
          if (this.registros[i].tipo.trim() == "AGENCIA") {
            this.agencia_si++;
          }
          if (this.registros[i].tipo.trim() == "CLIENTE TOP") {
            this.clientes_top_si++;
          }
          if (this.registros[i].tipo.trim() == "INVITADO TOP") {
            this.invitados_top_si++;
          }
          if (this.registros[i].tipo.trim() == "EQUIPO PROSA") {
            this.equipo_prosa_si++;
          }
          if (this.registros[i].tipo.trim() == "PATROCINADOR") {
            this.patrocinios_si++;
          }
          if (this.registros[i].tipo.trim() == "STAND") {
            this.stand_si++;
          }
        }

        //contador no asistirán
        if (
          this.registros[i].torneo == "NO" &&
          this.registros[i].clinica == "NO" &&
          this.registros[i].comida == "NO"
        ) {
          if (this.registros[i].tipo.trim() == "CLIENTE") {
            this.clientes_no++;
          }
          if (this.registros[i].tipo.trim() == "AGENCIA") {
            this.agencia_no++;
          }
          if (this.registros[i].tipo.trim() == "CLIENTE TOP") {
            this.clientes_top_no++;
          }
          if (this.registros[i].tipo.trim() == "INVITADO TOP") {
            this.invitados_top_no++;
          }
          if (this.registros[i].tipo.trim() == "EQUIPO PROSA") {
            this.equipo_prosa_no++;
          }

          if (this.registros[i].tipo.trim() == "STAND") {
            this.stand_no++;
          }
        }

        //no asistirán patrocinios
        if (
          this.registros[i].torneo == "NO" &&
          this.registros[i].clinica == "NO" &&
          this.registros[i].comida == "NO" &&
          this.registros[i].stand == "NO"
        ) {
          if (this.registros[i].tipo.trim() == "PATROCINADOR") {
            this.patrocinios_no++;
          }
        }

        if (this.registros[i].tipo.trim() == "CLIENTE") {
          this.contador_cliente++;
          if (this.registros[i].asistio == 1) {
            this.clientes_asistiendo++;
          }
        }
        if (this.registros[i].tipo.trim() == "AGENCIA") {
          this.contador_agencia++;
          if (this.registros[i].asistio == 1) {
            this.agencia_asistiendo++;
          }
        }
        if (this.registros[i].tipo.trim() == "CLIENTE TOP") {
          this.contador_cliente_top++;
          if (this.registros[i].asistio == 1) {
            this.clientes_top_asistiendo++;
          }
        }
        if (this.registros[i].tipo.trim() == "INVITADO TOP") {
          this.contador_invitado_top++;
          if (this.registros[i].asistio == 1) {
            this.invitados_top_asistiendo++;
          }
        }
        if (this.registros[i].tipo.trim() == "EQUIPO PROSA") {
          this.contador_equipo_prosa++;
          if (this.registros[i].asistio == 1) {
            this.equipo_prosa_asistiendo++;
          }
        }
        if (this.registros[i].tipo.trim() == "PATROCINADOR") {
          this.contador_patrocinador++;
          if (this.registros[i].asistio == 1) {
            this.patrocinios_asistiendo++;
          }
        }
        if (this.registros[i].tipo.trim() == "STAND") {
          this.contador_stand++;
          if (this.registros[i].asistio == 1) {
            this.stand_asistiendo++;
          }
        }
      }
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo);
              console.log(res.datos[0].email);

              this.signupForm.codigo = res.datos[0].codigo;
              //this.signupForm.email_user = res.datos[0].email;
              this.signupForm.nombre_1 = res.datos[0].nombre_1;
              this.signupForm.nombre_2 = res.datos[0].nombre_2;
              this.signupForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.signupForm.apellido_materno = res.datos[0].apellido_materno;
              this.signupForm.empresa = res.datos[0].empresa;
              this.signupForm.puesto = res.datos[0].puesto;
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;

              this.reenvioForm.codigo = "";

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else if (res.status === "reenvio") {
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    reenvio(codigo) {
      console.log({ reenvio: this.reenvioForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      this.reenvioForm.codigo = codigo;
      var qData = this.reenvioForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      console.log({ registro: this.signupForm });
      this.enviaRegistro();
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
              this.signupForm.codigo = "";
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signupInvitado(e) {
      e.preventDefault();

      console.log({ registro: this.signupForm });
      this.enviaInvitado();
    },
    async enviaInvitado() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro-invitado.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
              this.signupForm.codigo = "";

              this.getCodigoYDiponibilidad();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    changeComida(e) {
      if (this.signupForm.comida == "NO") {
        this.signupForm.talla_cubrebocas = "";
        this.signupForm.torneo = "NO";
        this.signupForm.clinica = "NO";
      }
      this.signupForm.talla_guantes = "";
      this.signupForm.horario_clinica = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeTorneo(e) {
      if (this.signupForm.torneo === "SI") {
        this.signupForm.clinica = "NO";
        this.signupForm.talla_guantes = "";
      } else {
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      }
    },
    changeClinica(e) {
      if (this.signupForm.clinica === "SI") {
        this.signupForm.torneo = "NO";
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      } else {
        this.signupForm.talla_guantes = "";
      }
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    resetForm() {
      this.signupForm = {
        codigo: "",
        nombre_1: "",
        nombre_2: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        codigo_pais: "",
        telefono: "",
        movil: "",
        torneo: false,
        handicap: "",
        talla_tops: "",
        clinica: false,
        talla_guantes: "",
        horario_clinica: "",
        talla_cubrebocas: "",
        terminos: false,
      };
      this.centroForm = {
        clasificacion: "",
        no_cliente: "",
        nombre_completo: "",
        cedis: "",
        objetivo_semanal: "",
      };
    },
    reenviarQR() {
      swal.fire("Bien", "Se ha reenviado el código QR.", "success");
    },
    enviarInvitacion(email) {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      this.preForm.email = email;
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "enviarInvitacion.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.getInvitados();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    async downloadImage(imageSrc, nombre, email) {
      const image = await fetch(imageSrc);
      const imageBlog = await image.blob();
      const imageURL = URL.createObjectURL(imageBlog);

      const link = document.createElement("a");
      link.href = imageURL;
      link.download = "QR-" + nombre + "-" + email + ".png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getCodigoYDiponibilidad() {
      console.log("get codigo y disponibilidad");

      const https = require("https");
      var qData = {};
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getCodigoYDisponibilidad.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.codigo_disponible = res.codigo_disponible;
              this.signupForm.codigo = res.codigo_disponible;

              this.cuenta_10am = res.cuenta_10am;
              this.cuenta_11am = res.cuenta_11am;
              this.cuenta_12pm = res.cuenta_12pm;
              this.cuenta_1pm = res.cuenta_1pm;
              this.cuenta_torneo = res.cuenta_torneo;
              this.cuenta_comida = res.cuenta_comida;

              this.topesForm.cuenta_comida = res.tope_comida;
              this.topesForm.cuenta_10am = res.tope_10am;
              this.topesForm.cuenta_11am = res.tope_11am;
              this.topesForm.cuenta_12pm = res.tope_12pm;
              this.topesForm.cuenta_1pm = res.tope_1pm;
              this.topesForm.cuenta_torneo = res.tope_torneo;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
  },
};
</script>

